import { MenuItem, Select } from '@mui/material'
import { NodeType } from 'shared/types/ingestion'
import React from 'react'

export function NodeTypeSelect({
  type,
  onSelect,
}: {
  type: string
  onSelect: (newType: string) => unknown
}) {
  return (
    <Select value={type} onChange={(e) => onSelect(e.target.value)}>
      {Object.values(NodeType).map((type) => (
        <MenuItem key={type} value={type}>
          {type}
        </MenuItem>
      ))}
    </Select>
  )
}
